import React from "react";
import { connect } from "react-redux";
import {
  Button,
  Paper,
  CssBaseline,
  TextField,
  Grid,
  Box,
  Typography,
  Container,
  FormControl,
  InputLabel,
  Select,
  FormHelperText,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { Helmet } from "react-helmet";
import { Formik } from "formik";
import * as Yup from "yup";
import { DynamicFormActions } from "../../redux/actions/DynamicFormAction";
import { history } from "../../components/helpers/History";
import { AppConstants } from "../../components/constants/ApplicationConstants";
import DynamicFields from "./DynamicFields";

const useStyles = (theme) => ({
  paper: {
    marginTop: theme.spacing(1),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    backgroundColor: "#fff",
    padding: theme.spacing(4),
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  typography: {
    margin: theme.spacing(3),
  },
  divider: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  buttons: {
    display: "flex",
    justifyContent: "center",
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
});

class DynamicForm extends React.Component {
  constructor(props) {
    super(props);
    const formid = this.props.match.params.formid?this.props.match.params.formid:'';
    this.state = {
      isDynamicFormUpdated : false,
      formName: "",
      displayName: "",
      formDescriptioin: "",
      isEsignatureRequired: false,
      formid:formid,
      status:'',
      formText: [
        {
          name: "",
          type: "Text",
          label:"",
          options: ""
        }
      ],
    };
  }

  handleAddFormFields = () => {
    let array = [...this.state.formText];
      array.push({
        name: "",
        type: "Text",
        label:"",
        options: ""
      })
      this.setState({formText:array}); 
  }
  handleRemoveFormFields = (indexValue) => {
    let array = [...this.state.formText];
    if (indexValue !== -1) {
        array.splice(indexValue, 1);
        this.setState({formText: array});
      }
    }
  handleFormChange = (index,name,value) => {
    let form = [...this.state.formText];
    if(name==="name"){
        form[index].name=value;
    }
    if(name==="type"){
        form[index].type=value;
    }
    if(name==="options"){
        form[index].options=value;
    }
    if(name==="label"){
        form[index].label=value;
    }
    this.setState({formText:form});
  }
  componentDidMount() {
    if(this.state.formid && this.state.formid.length > 0){
      this.props.findById(this.state.formid);
    }
  }

  componentDidUpdate(prevProps){
    
    if(this.props.dynamicFormDetails && this.props.dynamicFormDetails.id && this.state.id  != this.props.dynamicFormDetails.id){
      this.setState({
        id:this.props.dynamicFormDetails.id,
        formName: this.props.dynamicFormDetails.formName,
        displayName: this.props.dynamicFormDetails.displayName,
        formDescriptioin: this.props.dynamicFormDetails.formDescriptioin,
        isEsignatureRequired: this.props.dynamicFormDetails.isEsignatureRequired,
        status:this.props.dynamicFormDetails.status,
        formText:this.props.dynamicFormDetails.formText
      });
    }
    if(this.state.isDynamicFormUpdated  != this.props.isDynamicFormUpdated){
      this.setState({isDynamicFormUpdated:this.props.isDynamicFormUpdated});
      if(this.props.isDynamicFormUpdated){
        history.goBack();
      }
    }

  }
  componentWillUnmount() {
    this.props.clear();
  }
  validationObject = () => {
    let validationObject = {
      formName: Yup.string().max(100).required("Form name is required"),
      displayName: Yup.string().required("Form display name is required"),
      formDescriptioin: Yup.string().required("Form description name is required"),
      status: Yup.string().ensure().required("Status is required"),
    };
    return validationObject;
  };

  render() {
    const classes = this.props.classes;
    let textBoxContent = () => {
      if(this.state.formText && this.state.formText.length > 0){
        let textBoxContentList = [];
        this.state.formText.forEach((value, index) => {
          textBoxContentList.push(
            (
              <Grid item xs={12} md={12} key={index}>
                <DynamicFields name={value.name}
                label={value.label}
                type={value.type} options={value.options} index={index} 
                handleChange = {(indexValue,name,value) => {this.handleFormChange(indexValue,name,value)}}
                handleRemoveFormFields = {(indexValue)=>{this.handleRemoveFormFields(indexValue)}}
                />
              </Grid>
              ));  
        });
        return textBoxContentList;
      }else{
        return null;
      }
    }
    
    return (
      <>
        <Helmet>
          <title>RxRapidMad | Form Generation</title>
        </Helmet>
        <Container component="main" maxWidth={false}>
          <CssBaseline />
          <Box display="flex" >
              
                <Typography
                  gutterBottom
                  variant="h4"
                  color="primary"
                  className={classes.typography}
                >
                  Dynamic form generation
                </Typography>
              
              
            </Box>
          
          <Paper className={classes.paper}>
            <Formik  enableReinitialize
              initialValues={{
                formName: this.state.formName,
                displayName: this.state.displayName,
                formDescriptioin: this.state.formDescriptioin,
                isEsignatureRequired: this.state.isEsignatureRequired,
                id:this.state.id,
                status:this.state.status,
              }}
              validationSchema={Yup.object().shape(this.validationObject())}
              onSubmit={(values, { setSubmitting }) => {
                this.setState({ submitted: true });
                values.formText = [...this.state.formText];
                console.log(JSON.stringify(values));
                this.props.submit(values);
              }}
            >
              {({
                errors,
                handleBlur,
                handleChange,
                handleSubmit,
                touched,
                values,
              }) => (
                <form
                  onSubmit={handleSubmit}
                  className={classes.form}
                  noValidate
                  name="form"
                >
                  <Grid container spacing={1} >
                    <Grid item xs={12} sm={6}>
                      <TextField
                        error={Boolean(touched.formName && errors.formName)}
                        fullWidth
                        helperText={
                          touched.firstformNameName && errors.formName
                        }
                        label="Form Name"
                        margin="normal"
                        name="formName"
                        onBlur={handleBlur}
                        onChange={(e) => {
                          this.setState({ submitted: false });
                          handleChange(e);
                        }}
                        value={values.formName}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        error={Boolean(
                          touched.displayName && errors.displayName
                        )}
                        fullWidth
                        helperText={touched.displayName && errors.displayName}
                        label="Display Name"
                        margin="normal"
                        name="displayName"
                        onBlur={handleBlur}
                        onChange={(e) => {
                          this.setState({ submitted: false });
                          handleChange(e);
                        }}
                        value={values.displayName}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <TextField
                        error={Boolean(
                          touched.formDescriptioin && errors.formDescriptioin
                        )}
                        fullWidth
                        multiline
                        rows={4}
                        helperText={
                          touched.formDescriptioin && errors.formDescriptioin
                        }
                        label="Descirption"
                        margin="normal"
                        name="formDescriptioin"
                        onBlur={handleBlur}
                        onChange={(e) => {
                          this.setState({ submitted: false });
                          handleChange(e);
                        }}
                        value={values.formDescriptioin}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FormControl margin="normal" variant="outlined" className={classes.formControl} fullWidth>
                        <InputLabel htmlFor="status-label">Status</InputLabel>
                        <Select
                          native
                          value={values.status}
                          error={Boolean(touched.status && errors.status)}
                          helperText={touched.status && errors.status}
                          label="Status"
                          inputProps={{
                            name: 'status',
                            id: 'status-label',
                          }}
                          onBlur={handleBlur}
                          onChange={handleChange}
                        >
                          <option aria-label="None" value="" />
                          {AppConstants.USER_STATUS_LIST.map((element) => {
                              return(<option value={element.value}>
                                {element.label}
                              </option>)
                            })}
                        </Select>
                        {errors.status && touched.status && <FormHelperText style={{color:"#f44336"}}>{errors.status}</FormHelperText>}
                      </FormControl>
                     
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={values.isEsignatureRequired}
                            error={Boolean(
                              touched.isEsignatureRequired &&
                                errors.isEsignatureRequired
                            )}
                            fullWidth
                            helperText={
                              touched.isEsignatureRequired &&
                              errors.isEsignatureRequired
                            }
                            margin="normal"
                            name="isEsignatureRequired"
                            onBlur={handleBlur}
                            onChange={(e) => {
                              this.setState({ submitted: false });
                              handleChange(e);
                            }}
                            value={values.isEsignatureRequired}
                            checked={values.isEsignatureRequired}
                            variant="outlined"
                          />
                        }
                        label="Electronic signature required"
                      />
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <Box display="flex" flexDirection="row-reverse" p={1} m={1} bgcolor="background.paper">
                            <Box p={1} >
                            <Button variant="outlined" color="primary" onClick={()=>{this.handleAddFormFields()}}>
                                    Add
                                </Button>
                            </Box>
                        </Box>
                      <Grid container spacing={1} >

                      {textBoxContent()}
                      
                      
                      
                      
                      </Grid>
                      
                    </Grid>
                  </Grid>

                  <div className={classes.buttons}>
                    <Button
                      variant="contained"
                      color="default"
                      className={classes.button}
                      onClick={() => {
                        history.goBack();
                      }}
                    >
                      Cancel
                    </Button>
                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      className={classes.button}
                      disabled={this.state.submitted}
                    >
                      Submit
                    </Button>
                  </div>
                </form>
              )}
            </Formik>
          </Paper>
        </Container>
      </>
    );
  }
}

function mapStateToProps(state) {
  const dynamicFormDetails = state.dynamicform.dynamicFormDetails;
  const isDynamicFormUpdated = state.dynamicform.isDynamicFormUpdated;
  return { dynamicFormDetails,isDynamicFormUpdated };
}

const mapDispatchToProps = (dispatch) => {
  return {
    findById:(id)=>{dispatch(DynamicFormActions.getDynamicFormByIdRequest(id));},
    submit: (value) => {dispatch(DynamicFormActions.dynamicFormRequest(value));},
    clear: () => {dispatch(DynamicFormActions.clear());},
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles, { withTheme: true })(DynamicForm));
